import React, { useEffect, useRef, useState } from "react";
import "./resultados.css";
import videoResultados from "../../assets/resultados.mp4";

export default function Resultados() {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 },
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const checklistItems = [
    "Sites e landing pages desenvolvidos com foco em posicionamento e conversão.",
    "Estruturas digitais profissionais entregues para marcas que buscavam evoluir.",
    "Produção de vídeos estratégicos para fortalecer presença e autoridade.",
    "Projetos executados com planejamento, tecnologia e direção estratégica.",
  ];

  const openWhatsAppResultados = () => {
    const message =
      "Olá!%20Vim%20pelo%20site%20(Resultados)%20e%20gostaria%20de%20construir%20o%20próximo%20resultado%20com%20vocês.";
    window.open(`https://wa.me/5598986064394?text=${message}`, "_blank");
  };

  return (
    <section id="resultados" className="resultados-section" ref={sectionRef}>
      <div className="resultados-container">
        <div
          className={`resultados-content ${isVisible ? "animate-left" : ""}`}
        >
          <h2 className="resultados-titulo">
            RESULTADOS QUE JÁ <br />
            <strong>ENTREGAMOS</strong>
          </h2>

          <ul className="resultados-checklist">
            {checklistItems.map((item, index) => (
              <li key={index} style={{ transitionDelay: `${index * 0.2}s` }}>
                <span className="check-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                  >
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                {item}
              </li>
            ))}
          </ul>

          {/* NOVO: Texto de reforço do Método ÁPICE */}
          <p className="frase-metodo-resultados">
            Resultados construídos com o Método ÁPICE
          </p>

          <button onClick={openWhatsAppResultados} className="btn-resultados">
            Vamos construir o próximo resultado
            <span className="arrow-down">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M6 9l6 6 6-6" />
              </svg>
            </span>
          </button>
        </div>

        <div className={`resultados-media ${isVisible ? "animate-right" : ""}`}>
          <div className="video-wrapper">
            <video
              src={videoResultados}
              autoPlay
              loop
              muted
              playsInline
              className="video-element"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
